import defaultLocales from 'globals/locales/default';
import {
  FsKeysGroupFormDataProps,
  KeysSingleField,
} from 'ui-elements/forms/FsKeysGroupForm/FsKeysGroupForm';

interface FieldGroupProps {
  clientId?: string;
  clientSecret?: string;
}

const getSandboxFields = ({
  clientId,
  clientSecret,
}: FieldGroupProps): KeysSingleField[] => [
  {
    name: defaultLocales.clientId,
    value: clientId || '',
    type: 'password',
  },
  {
    name: defaultLocales.clientSecret,
    value: clientSecret || '',
    type: 'password',
  },
];

export const getSandboxFieldGroupProps = (
  props: FieldGroupProps
): FsKeysGroupFormDataProps => ({
  fields: getSandboxFields(props),
});

const getProductionFields = ({
  clientId,
  clientSecret,
}: FieldGroupProps): KeysSingleField[] => [
  {
    name: defaultLocales.clientId,
    value: clientId || '',
    type: 'password',
  },
  {
    name: defaultLocales.clientSecret,
    value: clientSecret || '',
    type: 'password',
  },
];

export const getProductionFieldGroupProps = (
  props: FieldGroupProps
): FsKeysGroupFormDataProps => ({
  fields: getProductionFields(props),
});
